import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class PropertyTaxDetail {
    constructor(doc)
    {
		this.label = null
		this.propertyTaxAbatementsOrExemptionsIndicator = null
		this.specialTaxAssessmentsIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.propertyTaxAbatementsOrExemptionsIndicator = x.getBooleanElement(doc, "./ns:PropertyTaxAbatementsOrExemptionsIndicator");
		this.specialTaxAssessmentsIndicator = x.getBooleanElement(doc, "./ns:SpecialTaxAssessmentsIndicator");
   }
}

export class PropertyTaxExemption {
    constructor(doc)
    {
		this.label = null
		this.taxAbatementsOrExemptionsAnnualAmount = null;
		this.taxAbatementsOrExemptionsExpirationDate = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.taxAbatementsOrExemptionsAnnualAmount  = x.getMISMOAmountElement(doc, "./ns:TaxAbatementsOrExemptionsAnnualAmount");
		this.taxAbatementsOrExemptionsExpirationDate = x.getMISMODateElement(doc, "./ns:TaxAbatementsOrExemptionsExpirationDate");
   }
}

export class PropertyTaxes {
    constructor(doc)
    {
		this.label = null
		this.propertyTaxDetail = null
		this.propertyTaxExemptions = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:PROPERTY_TAX_DETAIL");
		if (node !== null)
				this.propertyTaxDetail = new PropertyTaxDetail(node);
		nodes = x.selectNodes(doc, "./ns:PROPERTY_TAX_EXEMPTIONS/ns:PROPERTY_TAX_EXEMPTION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.propertyTaxExemptions.push(new PropertyTaxExemption(xn));
			});
		}
   }

	GetAbatementAnnualAmount() {
		if (this.propertyTaxExemptions.length === 0) return null;
		var value = 0;
		for (var pte of this.propertyTaxExemptions)
			value += pte.taxAbatementsOrExemptionsAnnualAmount.Value;

		return h.toDollarAmount(value);
	}

	GetAbatementExpirationDate() {
		if (this.propertyTaxExemptions.length === 0) return "";
		var dates = "";
		for (var pte of this.propertyTaxExemptions)
			dates = h.addWithSpacer(dates, pte.taxAbatementsOrExemptionsExpirationDate.FormatMDY());

		return dates;
	}

}

